export const environment = {
  production: false,
  name: 'test',
  backendUrl: '__API_URL__',
  themesAndAssetsUrl: 'https://ajilach.github.io/angular-material-themes/public/',
  themeStage: 'test',
  themeTenant: 'fhco'
};
